<template>
  <v-card-actions class="grey lighten-4 px-0">
    <table>
      <tr>
        <th class="text-caption grey--text text--darken-1" v-text="__('sum')" />
        <th class="text-caption grey--text text--darken-1" v-text="__('discounts')" />
        <th class="text-caption grey--text text--darken-1" v-text="__('subtotal')" />
        <th class="text-caption grey--text text--darken-1" v-text="__('tax')" />
        <th class="text-caption grey--text text--darken-1" v-text="__('total')" />
      </tr>
      <tr>
        <td class="text-body-2">{{ order.sum | currency }}</td>
        <td class="text-body-2">{{ order.discountAmount | currency }}</td>
        <td class="text-body-2">{{ order.subtotal | currency }}</td>
        <td class="text-body-2">{{ order.taxAmount | currency }}</td>
        <td class="text-body-2 font-weight-bold">{{ order.total | currency }}</td>
      </tr>
    </table>
  </v-card-actions>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      Currenciable,
      I18n,
    ],

    computed: {
      order () {
        return this.$store.state.orders.current
      },
    },
  }
</script>

<style lang="scss" scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    th, td {
      width: 20%;
      text-align: center;
    }
  }
</style>
